import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Public pages
import StartPage from './pages/StartPage';
import ChatPage from './pages/ChatPage';
import ReportPage from './pages/ReportPage';

// Admin pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminContacts from './pages/admin/AdminContacts';
import AdminContactDetail from './pages/admin/AdminContactDetail';
import AdminUsers from './pages/admin/AdminUsers';

// Layout
import AdminLayout from './components/Layout/AdminLayout';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/start" element={<StartPage />} />
      <Route path="/chat/:contactId" element={<ChatPage />} />
      <Route path="/report/:contactId" element={<ReportPage />} />

      {/* Admin routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="contacts" element={<AdminContacts />} />
        <Route path="contacts/:id" element={<AdminContactDetail />} />
        <Route path="users" element={<AdminUsers />} />
      </Route>

      {/* Default redirect */}
      <Route path="*" element={<Navigate to="/start" replace />} />
    </Routes>
  );
}

export default App;
